import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=672b0da7&scoped=true&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"
import style0 from "./Signin.vue?vue&type=style&index=0&id=672b0da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b0da7",
  null
  
)

export default component.exports